import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

export const TokenUsageSchema = z.object({
  input: z.number().int().min(0),
  output: z.number().int().min(0),
  total: z.number().int().min(0),
});
export type TokenUsage = z.infer<typeof TokenUsageSchema>;

export const DraftSchema = z.object({
  id: IdSchema,
  conversationId: IdSchema,
  generatedById: IdSchema,
  content: z.string(),
  rationale: z.string().nullable(),
  model: z.string(),
  promptVersion: z.string(),
  tokenUsage: TokenUsageSchema,
  wasUsed: z.boolean(),
  createdAt: TimestampSchema,
});
export type Draft = z.infer<typeof DraftSchema>;

export const GenerateDraftSchema = z.object({
  // Rep's optional one-off context for this generation
  repContext: z.string().max(2000).optional(),
});
export type GenerateDraftInput = z.infer<typeof GenerateDraftSchema>;

// SSE event payloads
export const SseTokenEventSchema = z.object({
  type: z.literal('token'),
  delta: z.string(),
});
export const SseCompleteEventSchema = z.object({
  type: z.literal('complete'),
  draft: DraftSchema,
});
export const SseErrorEventSchema = z.object({
  type: z.literal('error'),
  code: z.string(),
  message: z.string(),
});
export const SseGenerateEventSchema = z.discriminatedUnion('type', [
  SseTokenEventSchema,
  SseCompleteEventSchema,
  SseErrorEventSchema,
]);
export type SseGenerateEvent = z.infer<typeof SseGenerateEventSchema>;
